import React from 'react';
import PropTypes from "prop-types";

const ExpandSection = (props) => {
  return (
    <div className={"ui-expand" + (props.opened ? " ui-expand--opened" : "")}>
      <div className="ui-expand__button" onClick={props.onClick}>
        <span className="ui-expand__button-triangle"/>
        <h3 className="ui-expand__button-title">{props.title}</h3>
      </div>
      <div className="ui-expand__content">{props.children}</div>
    </div>
  )
}

ExpandSection.propTypes = {
  opened: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  children: PropTypes.object.isRequired
};

export default ExpandSection
